"use client";

import React from "react";
import { MapPin, ShieldCheck, Smartphone } from "lucide-react";

export default function ContactUsContent() {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-lg">
        <div className="border-b border-gray-100 px-8 py-10 text-center">
          <h1 className="text-3xl font-bold text-gray-900">CardBox support</h1>
          <p className="mx-auto mt-3 max-w-2xl text-gray-600">
            CardBox support is handled through the app so your verified account
            and relevant service details stay connected to the request.
          </p>
        </div>

        <div className="grid gap-5 px-8 py-10 md:grid-cols-2">
          <section className="rounded-xl border border-blue-100 bg-blue-50 p-6">
            <Smartphone className="h-7 w-7 text-primary" />
            <h2 className="mt-4 text-lg font-bold text-gray-900">
              Get help in CardBox
            </h2>
            <p className="mt-2 text-sm leading-6 text-gray-600">
              Open the CardBox app and use the relevant Help &amp; information
              option. During provider setup, tap Onboarding help to request a
              support callback.
            </p>
          </section>

          <section className="rounded-xl border border-gray-200 bg-gray-50 p-6">
            <MapPin className="h-7 w-7 text-primary" />
            <h2 className="mt-4 text-lg font-bold text-gray-900">Location</h2>
            <p className="mt-2 text-sm leading-6 text-gray-600">
              Bhagalpur, Bihar, India
            </p>
          </section>

          <section className="flex gap-3 rounded-xl border border-amber-200 bg-amber-50 p-5 md:col-span-2">
            <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" />
            <p className="text-sm leading-6 text-amber-900">
              CardBox support will never ask for your password, complete OTP,
              authentication token or full payment credentials.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
